(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const productCards = document.querySelectorAll('.product-card[data-bg-color][data-border-color]');
    productCards.forEach(card => {
      const bgColor = card.getAttribute('data-bg-color');
      const borderColor = card.getAttribute('data-border-color');
      card.style.setProperty('--bg-color', bgColor);
      card.style.setProperty('--border-color', borderColor);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.featured-cards-container');
    const wrapper = document.querySelector('.featured-cards-wrapper');
    
    if (!container || !wrapper) return;
    
    let isDown = false;
    let startX;
    let currentTranslate = 0;
    let prevTranslate = 0;
    
    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }
    
    function dragStart(e) {
      isDown = true;
      if (e.type === 'mousedown') {
        container.style.cursor = 'grabbing';
      }
      startX = getPositionX(e);
      prevTranslate = currentTranslate;
    }
    
    function dragEnd() {
      isDown = false;
      container.style.cursor = 'grab';
    }
    
    function dragMove(e) {
      if (!isDown) return;
      e.preventDefault();
      
      const currentPosition = getPositionX(e);
      const diff = currentPosition - startX;
      currentTranslate = prevTranslate + diff;
      
      const maxScroll = -(wrapper.scrollWidth - container.offsetWidth);
      
      // Constrain the scroll
      if (currentTranslate > 0) {
        currentTranslate = 0;
      } else if (currentTranslate < maxScroll) {
        currentTranslate = maxScroll;
      }
      
      wrapper.style.transform = `translateX(${currentTranslate}px)`;
    }
    
    // Mouse events
    container.addEventListener('mousedown', dragStart);
    container.addEventListener('mouseleave', dragEnd);
    container.addEventListener('mouseup', dragEnd);
    container.addEventListener('mousemove', dragMove);
    
    // Touch events
    container.addEventListener('touchstart', dragStart);
    container.addEventListener('touchend', dragEnd);
    container.addEventListener('touchmove', dragMove);
    
    container.style.cursor = 'grab';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
